export const aboutInfo = {
  brandName: '高清无码指南',
  brandIntro: '「高清无码指南」成立于 2024 年，是国内首个系统性聚焦高清视频编码与画质优化的专业技术内容平台。我们汇聚了一群来自视频编解码、数字影像处理和流媒体分发领域的资深从业者，致力于为视频创作者、技术爱好者和行业从业者提供最专业、最实用的高清视频技术内容。',
  mission: '我们相信每一帧画面都值得被完美呈现。在这个视频内容爆炸式增长的时代，帮助每一位创作者用最合适的技术方案呈现最优质的视觉体验——这正是「高清无码指南」存在的意义。',
  stats: [
    { label: '原创技术文章', value: '200+' },
    { label: '编码评测报告', value: '50+' },
    { label: '月活跃读者', value: '15万+' },
    { label: '行业合作伙伴', value: '30+' },
  ],
  team: [
    { name: '张明远', role: '主编 / 编码技术专家', bio: '前视频编码算法工程师，10 年视频技术从业经验，精通 H.264/H.265/AV1 编码标准。' },
    { name: '李思涵', role: '高级编辑 / 画质评测师', bio: '数字影像处理硕士，专注于视频画质客观评估与主观评测方法研究。' },
    { name: '陈志远', role: '技术编辑 / 播放器兼容性专家', bio: '全栈开发者出身，对跨平台播放器解码性能和兼容性有深入研究。' },
    { name: '王浩然', role: '内容总监 / 制作流程顾问', bio: '前影视后期制作总监，参与过 50+ 商业广告与纪录片的后期制作。' },
  ],
  testimonials: [
    { content: '「高清无码指南」的内容质量在中文视频技术圈是独一档的。每次遇到编码参数调优的问题，第一反应就是来这查。强烈推荐给每一位认真对待视频画质的创作者。', author: '刘导演', role: '独立电影导演' },
    { content: '作为一个从摄影转视频的创作者，编码这块一直是我的短板。这个网站的系统性文章让我在短时间内就掌握了编码优化的核心要点，视频画质提升立竿见影。', author: '小林同学', role: 'B站 UP 主 / 摄影师' },
    { content: '我们团队把「高清无码指南」设为新人培训的必读资料。文章深度和专业性完全可以媲美国外顶级技术博客，而且中文表达更加精准易懂。', author: '赵总监', role: '某 MCN 机构技术负责人' },
  ],
  contact: {
    email: 'contact@hd-guide.cn',
    wechat: 'HD-Guide-Official',
    address: '北京市海淀区中关村科技园区',
  },
};